export * from './asset.service';
import { AssetService } from './asset.service';
export * from './contractAgreement.service';
import { ContractAgreementService } from './contractAgreement.service';
export * from './contractDefinition.service';
import { ContractDefinitionService } from './contractDefinition.service';
export * from './contractNegotiation.service';
import { ContractNegotiationService } from './contractNegotiation.service';
import { EdrService } from './edr.service';
export * from './policy.service';
import { PolicyService } from './policy.service';
import { PublicService } from './public.service';
export * from './transferProcess.service';
import { TransferProcessService } from './transferProcess.service';
export const APIS = [AssetService, ContractAgreementService, ContractDefinitionService, ContractNegotiationService, PolicyService, TransferProcessService, EdrService, PublicService];
